import { useState, useEffect, useCallback } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isIPad: boolean;
  screenWidth: number;
  screenHeight: number;
  orientation: 'portrait' | 'landscape';
}

export const useDeviceDetection = (baseMobileCondition: boolean = false) => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isIPad: false,
    screenWidth: 0,
    screenHeight: 0,
    orientation: 'portrait',
  });

  const detectDevice = useCallback(() => {
    const userAgent = navigator.userAgent;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const orientation: 'portrait' | 'landscape' = screenWidth > screenHeight ? 'landscape' : 'portrait';

    // console.log('userAgent', userAgent);
    // console.log('screenWidth', screenWidth);
    // console.log('screenHeight', screenHeight);
    // console.log('orientation', orientation);

    // iPad detection
    const isIPad = /iPad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // General tablet detection (including iPad and Android tablets)
    const isTablet = isIPad || (screenWidth >= 768 && screenWidth <= 1366) || /tablet|ipad|playbook|silk/i.test(userAgent);

    // Mobile detection
    const isMobile = baseMobileCondition || screenWidth < 768 || /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|X11|Windows Phone/i.test(userAgent);

    return {
      isMobile,
      isTablet,
      isIPad,
      screenWidth,
      screenHeight,
      orientation,
    };
  }, [baseMobileCondition]);

  useEffect(() => {
    const updateDeviceInfo = () => {
      setDeviceInfo(detectDevice());
    };

    // Initial detection
    updateDeviceInfo();

    // Listen for resize and orientation changes
    window.addEventListener('resize', updateDeviceInfo);
    window.addEventListener('orientationchange', updateDeviceInfo);

    return () => {
      window.removeEventListener('resize', updateDeviceInfo);
      window.removeEventListener('orientationchange', updateDeviceInfo);
    };
  }, [detectDevice]);

  // Helper function to determine if should use mobile layout
  const shouldUseMobileLayout = useCallback(() => {
    return deviceInfo.isMobile || deviceInfo.isIPad || (deviceInfo.isTablet && deviceInfo.screenWidth < 1030) || deviceInfo.screenWidth < 1190;
  }, [deviceInfo]);

  return {
    ...deviceInfo,
    shouldUseMobileLayout,
  };
};
